module.exports = __webpack_public_path__ + "img/blurred-logo.1cef5742.png";